<template>
  <div>
    <groups :items="groups" v-model="group_id" :nav="nav" @navigate="setNav" />
    <component
      v-if="group_id && isShow === true"
      :is="nav"
      :group_id="group_id"
    />
    <div v-else class="teacher-area">
      <card>
        <h4>{{ "change_group" | setText("Выберите класс") }}</h4>
      </card>
    </div>
  </div>
</template>
<script>
import { getGroups, getClients } from "@/_api/apiPupil";
import groups from "@/components/Pupils/Groups";
import chat from "@/components/Pupils/Chat";
import journal from "@/components/Pupils/Journal";
import conference from "@/components/Pupils/Conference";
import notifications from "@/components/Pupils/Notifications";
import Decisions from "@/components/Pupils/Decisions";
export default {
  name: "pupils",
  methods: {
    getGroups: getGroups,
    getClients: getClients,
    setNav(val) {
      this.nav = val;
    },
  },
  components: {
    groups,
    chat,
    journal,
    conference,
    notifications,
    Decisions,
  },
  watch: {
    group_id(val) {
      this.isShow = false;

      setTimeout(() => {
        this.isShow = true;
      }, 20);
    },
  },
  mounted() {
    if (this.$route.query.group_id) {
      this.group_id = this.$route.query.group_id;
    }
    if (this.$route.query.nav) {
      this.nav = this.$route.query.nav;
    }
    this.isShow = true;
    this.getGroups();
  },
  data() {
    return {
      isShow: false,
      groups: [],
      group_id: null,
      nav: "journal",
    };
  },
};
</script>

